import { render, staticRenderFns } from "./SpiderDoor.vue?vue&type=template&id=1d7f23ab&scoped=true&"
import script from "./SpiderDoor.vue?vue&type=script&lang=js&"
export * from "./SpiderDoor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7f23ab",
  null
  
)

export default component.exports